<div *ngIf="isEpic" class="epic-label">
  <nb-form-field>
    <input #epicNameElement nbInput fullWidth fieldSize="small" type="text"
         [formControl]="epicNameControl"
         [ngClass]="{'valid': epicNameControl.valid, 'invalid': epicNameControl.invalid}"
         (focusout)="changeEpicName()"
         (keyup.enter)="changeEpicName()"/>
    <nb-icon nbSuffix [icon]="'alert-triangle-outline'" status="warning" *ngIf="epicNameControl.invalid"></nb-icon>
  </nb-form-field>
</div>
<div *ngIf="isParentAnEpic || showAutocompleteForm" class="epic-label" (click)="showAutocomplete()">
  <div class="epic-link" *ngIf="!showAutocompleteForm"><a [routerLink]="[]" (click)="showAutocomplete(); $event.preventDefault()">{{epicName}}</a></div>
  <nb-form-field *ngIf="showAutocompleteForm">
    <input #epicSearchElement nbInput fullWidth fieldSize="small" type="text"
           (focus)="epicSearchElement.select()"
           (focusout)="onFocusOut()"
           [formControl]="autocompleteControl"
           [matAutocomplete]="auto"/>
    <button nbSuffix nbButton ghost size="small" nbTooltip="Удалить"
            *ngIf="selectedIssueId !== null && autocompleteControl.valid" (click)="deleteEpic()">
      <nb-icon [icon]="'close-outline'"></nb-icon>
    </button>
    <nb-icon nbSuffix [icon]="'alert-triangle-outline'" status="warning" *ngIf="autocompleteControl.invalid"></nb-icon>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onChangeEpic($event)">
      <mat-option *ngFor="let epic of epicList$ | async" [value]="epic">
        <span class="epic-option-name">{{epic.epicName}}</span>
        <span class="epic-option-code">{{epic.issueId}}</span>
      </mat-option>
    </mat-autocomplete>
  </nb-form-field>
</div>
<div *ngIf="!isEpic && !isParentAnEpic && !showAutocompleteForm" class="epic-label" (click)="showAutocomplete()">
  <span class="no-epic">нет</span>
</div>
